import EventManager from 'dd-event-manager';



// const SCROLL_EVENT  = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
const SCROLL_END_JUDGE_INTERVAL = 500;



export default class WindowManager {
  scroll              = {top: null, left: null};
  scrollDiff          = {start: {top: null, left: null}, top: null, left: null};
  scrollTimerId       = null;
  nowScroll           = false;
  hiddenKey           = null;
  visibilityChangeKey = null;
  showState           = 'show';



  get isShow() { return this.showState === 'show' }
  get isHide() { return this.showState === 'hide' }



  /**
   * constructor
   */
  constructor() {
    new EventManager(this);

    const onWindowLoad = e => {
      this._updateParams();

      // this.emit('load', this);

      // IE、EDGEでウェイトをおかないと要素の短径が正しくとれない
      setTimeout(() => {
        this.emit('load', this);
      }, 250);

      window.removeEventListener('load', onWindowLoad, false);
    }

    const onWindowResize = e => {
      return this._onResize(e);
    }

    const onWindowScroll = e => {
      return this._onScroll(e);
    }

    window.addEventListener('load', onWindowLoad, false);
    window.addEventListener('resize', onWindowResize, false);
    window.addEventListener('orientationchange', onWindowResize, false);
    window.addEventListener('scroll', onWindowScroll, false);

    this.setupVisibilityEvent();
  }



  /**
   * ready hook
   */
  ready(cb) {
    return new Promise((resolve, reject) => {
      this.hasAndOne('load', () => {
        if (typeof cb === 'function') cb(this);
        resolve(this);
      });
    });
  }



  /**
   * on resize callback
   */
  _onResize() {
    this._updateScrollParams();
    this._updateSize();
  }



  /**
   * on scrll callback
   */
  _onScroll() {
    if (!this.nowScroll) {
      this.scrollDiff.start.top  = this.scroll.top;
      this.scrollDiff.start.left = this.scroll.left;
    }

    this._updateScrollParams();

    this.scrollDiff.top  = this.scroll.top  - this.scrollDiff.start.top;
    this.scrollDiff.left = this.scroll.left - this.scrollDiff.start.left;

    if (!this.nowScroll) {
      this.nowScroll = true;
      this.emit('scrollStart', this);
    }

    this.emit('scroll', this);

    if (this.scrollTimerId !== null) {
      clearTimeout(this.scrollTimerId);
      this.scrollTimerId = null;
    }

    this.scrollTimerId = setTimeout(() => {
      this.nowScroll = false;
      this.emit('scrollEnd', this);
    }, SCROLL_END_JUDGE_INTERVAL);
  }



  /**
   * update all params
   */
  _updateParams() {
    this._updateScrollParams();
    this._updateSize();
  }



  /**
   * update scroll params
   */
  _updateScrollParams() {
    this.scroll.top  = window.pageYOffset;
    this.scroll.left = window.pageXOffset;
  }



  /**
   * update size params
   */
  _updateSize() {
    let bw = this.width, bh = this.height;

    this.width  = window.innerWidth;
    this.height = window.innerHeight;

    if (bw === null) return;

    if (bw !== this.width || bh !== this.height) {
      this.emit('resize', this);
    }
  }



  /**
   * setup visibility event
   */
  setupVisibilityEvent() {
    const handleVisibilityChange = e => {
      updateState();
    }

    const updateState = () => {
      const beforeState = this.showState;
      this.showState = document[this.hiddenKey] ? 'hide' : 'show';
      if (beforeState !== this.showState) {
        this.emit(this.showState, this);
      }
    }

    if (document.hidden !== undefined) {
      this.hiddenKey = 'hidden';
      this.visibilityChangeKey = 'visibilitychange';
    } else if (document.mozHidden !== undefined) {
      this.hiddenKey = 'mozHidden';
      this.visibilityChangeKey = 'mozvisibilitychange';
    } else if (document.msHidden !== undefined) {
      this.hiddenKey = 'msHidden';
      this.visibilityChangeKey = 'msvisibilitychange';
    } else if (document.webkitHidden !== undefined) {
      this.hiddenKey = 'webkitHidden';
      this.visibilityChangeKey = 'webkitvisibilitychange';
    }

    if (!this.hiddenKey) {
      console.warn('ブラウザが `Page Visibility API` に対応していないため、イベントの発行を行いません。');
      return;
    }

    if (document.addEventListener === undefined || !this.hiddenKey) {
      console.warn('ブラウザが `Page Visibility API` に対応していないため、イベントの発行を行いません。');
      return;
    }

    document.addEventListener(this.visibilityChangeKey, handleVisibilityChange, false);
    updateState();
  }
}



// WEBPACK FOOTER //
// ./src/shared/core/WindowManager.js